var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (artistResults, artists, artworks, counts, disableEnd, disableStart, includeContext, isTouch, s, showHeader, suggestions, undefined) {
var viewAllUrl = "/works-for-you"
buf.push("<div data-rail=\"followed_artists\" class=\"abrv-inner\"><div class=\"abrv-header\">");
if ( showHeader)
{
if ( artworks && artworks.length)
{
buf.push("<h1>Works by artists you follow</h1>");
}
else
{
buf.push("<h1>Follow artists and keep up-to-date</h1>");
}
buf.push("<a" + (jade.attr("href", viewAllUrl, true, true)) + " class=\"abrv-view-all\">View all</a>");
}
buf.push("</div><div class=\"abrv-content\"><div class=\"abrv-carousel mgr-horizontal-nav js-my-carousel\">");
if ( artworks && artworks.length)
{
buf.push("<ul" + (jade.cls(['abrv-fillwidth-list','fillwidth-list','js-mgr-cells','mgr-cells',artworks ? '' : 'mgr-cells--loading'], [null,null,null,null,true])) + "><li class=\"abrv-context mgr-cell abrv-fillwidth-row js-mgr-cell\"><div class=\"abrv-context__content abrv-context__content--followed-artists\">");
if ( artists && artists.length)
{
// iterate artists
;(function(){
  var $$obj = artists;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var artist = $$obj[$index];

buf.push("<a" + (jade.attr("href", "/artist/" + (artist.id) + "", true, true)) + " class=\"abrv-context__content--followed-artists__artist\">" + (jade.escape(null == (jade_interp = artist.get('name')) ? "" : jade_interp)) + "</a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var artist = $$obj[$index];

buf.push("<a" + (jade.attr("href", "/artist/" + (artist.id) + "", true, true)) + " class=\"abrv-context__content--followed-artists__artist\">" + (jade.escape(null == (jade_interp = artist.get('name')) ? "" : jade_interp)) + "</a>");
    }

  }
}).call(this);

if ( counts.artists - artists.length > 0)
{
s = counts.artists - artists.length == 1 ? '' : 's'
buf.push("<a href=\"/works-for-you\" class=\"abrv-context__content--followed-artists__more-artists\">+" + (jade.escape((jade_interp = counts.artists - artists.length) == null ? '' : jade_interp)) + " more artist" + (jade.escape((jade_interp = s) == null ? '' : jade_interp)) + "</a>");
}
}
else
{
buf.push("<p>Follow artists for better recommendations and to receive alerts when new works are available</p><P><span>Or&nbsp;</span><a href=\"/artists\">Browse all artists</a></P>");
}
buf.push("</div></li>");
// iterate artworks
;(function(){
  var $$obj = artworks;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var artwork = $$obj[$index];

buf.push("<li class=\"mgr-cell abrv-fillwidth-row js-mgr-cell\"><div" + (jade.attr("data-id", artwork.id, true, true)) + " data-type=\"artwork\"" + (jade.attr("style", 'width: ' + (artwork.image.cell.width) + 'px', true, true)) + " class=\"artwork-brick artwork-brick--on-rail js-artwork-brick\"><div class=\"artwork-brick__image\"><a" + (jade.attr("href", artwork.href, true, true)) + "><img" + (jade.attr("src", artwork.image.cell.url, true, true)) + (jade.attr("alt", artwork.title, true, true)) + (jade.attr("width", artwork.image.cell.width, true, true)) + (jade.attr("height", artwork.image.cell.height, true, true)) + " onerror=\"this.style.display=&quot;none&quot;;\" class=\"artwork-brick__image__img\"></a><div" + (jade.attr("data-id", artwork.id, true, true)) + " class=\"artwork-brick__image__save js-artwork-brick-save-controls\"></div></div><div class=\"artwork-metadata-stub\">");
if ( artwork.cultural_maker)
{
buf.push("<h4 class=\"artwork-metadata-stub__artists artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.cultural_maker) ? "" : jade_interp)) + "</h4>");
}
else if ( artwork.artists && artwork.artists.length)
{
buf.push("<h4 class=\"artwork-metadata-stub__artists artwork-metadata-stub__line\">");
// iterate artwork.artists
;(function(){
  var $$obj = artwork.artists;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var artist = $$obj[i];

buf.push("<a" + (jade.attr("href", artist.href, true, true)) + ">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
if (!( i === artwork.artists.length - 1))
{
buf.push(jade.escape(null == (jade_interp = ', ') ? "" : jade_interp));
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var artist = $$obj[i];

buf.push("<a" + (jade.attr("href", artist.href, true, true)) + ">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
if (!( i === artwork.artists.length - 1))
{
buf.push(jade.escape(null == (jade_interp = ', ') ? "" : jade_interp));
}
    }

  }
}).call(this);

buf.push("</h4>");
}
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + " class=\"artwork-metadata-stub__title artwork-metadata-stub__line\"><em>" + (jade.escape(null == (jade_interp = artwork.title) ? "" : jade_interp)) + "</em>");
if ( artwork.date)
{
buf.push(", " + (jade.escape((jade_interp = artwork.date) == null ? '' : jade_interp)) + "");
}
buf.push("</a>");
if ( artwork.collecting_institution)
{
buf.push("<div class=\"artwork-metadata-stub__partner artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.collecting_institution) ? "" : jade_interp)) + "</div>");
}
else if ( artwork.sale && artwork.sale.is_auction)
{
buf.push("<a" + (jade.attr("href", artwork.sale.href, true, true)) + " class=\"artwork-metadata-stub__partner artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.partner.name) ? "" : jade_interp)) + "</a>");
}
else if ( artwork.partner)
{
buf.push("<a" + (jade.attr("href", artwork.partner.href, true, true)) + " class=\"artwork-metadata-stub__partner artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.partner.name) ? "" : jade_interp)) + "</a>");
}
if ( artwork.sale_message && artwork.sale_message != 'Contact For Price' && !(artwork.sale && artwork.sale.is_auction))
{
buf.push("<div class=\"artwork-metadata-stub__sale-message artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.sale_message) ? "" : jade_interp)) + "</div>");
}
var auctionPartner = artwork.partner && (artwork.partner.type === 'Auction' || artwork.partner.type === 'Auction House')
if ( artwork.sale && artwork.sale.is_auction)
{
if ( artwork.is_sold)
{
buf.push("<div class=\"artwork-metadata-stub__contact artwork-metadata-stub__line\">Sold</div>");
}
else
{
buf.push("<div class=\"artwork-metadata-stub__contact artwork-metadata-stub__line artwork-metadata-stub__bid-now\">");
var sa = artwork.sale_artwork
if ( artwork.sale.is_live_open)
{
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + ">Enter Live Auction</a>");
}
else if ( artwork.sale.is_open)
{
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + ">");
var bids = sa.counts.bidder_positions
if ( bids > 0)
{
buf.push("" + (jade.escape((jade_interp = sa.highest_bid.display) == null ? '' : jade_interp)) + "&nbsp;" + (jade.escape(null == (jade_interp = '(' + bids + (bids > 1 ? ' bids' : ' bid') + ')') ? "" : jade_interp)));
}
else
{
buf.push("" + (jade.escape((jade_interp = sa.opening_bid.display) == null ? '' : jade_interp)) + "");
}
buf.push("</a>");
}
else if ( artwork.sale.is_preview)
{
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + ">" + (jade.escape((jade_interp = sa.opening_bid.display) == null ? '' : jade_interp)) + "</a>");
}
else if ( artwork.sale.is_closed)
{
buf.push("Auction closed");
}
buf.push("</div>");
}
}
else if ( artwork.is_inquireable && !artwork.is_acquireable)
{
buf.push("<div class=\"artwork-metadata-stub__contact artwork-metadata-stub__line\"><a" + (jade.attr("href", artwork.href, true, true)) + (jade.attr("data-artwork_id", artwork._id, true, true)) + " data-context_type=\"artwork feed item\" class=\"analytics-artwork-contact-seller\">Contact " + (jade.escape((jade_interp = artwork.partner.type.toLowerCase()) == null ? '' : jade_interp)) + "</a></div>");
}
buf.push("</div></div></li>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var artwork = $$obj[$index];

buf.push("<li class=\"mgr-cell abrv-fillwidth-row js-mgr-cell\"><div" + (jade.attr("data-id", artwork.id, true, true)) + " data-type=\"artwork\"" + (jade.attr("style", 'width: ' + (artwork.image.cell.width) + 'px', true, true)) + " class=\"artwork-brick artwork-brick--on-rail js-artwork-brick\"><div class=\"artwork-brick__image\"><a" + (jade.attr("href", artwork.href, true, true)) + "><img" + (jade.attr("src", artwork.image.cell.url, true, true)) + (jade.attr("alt", artwork.title, true, true)) + (jade.attr("width", artwork.image.cell.width, true, true)) + (jade.attr("height", artwork.image.cell.height, true, true)) + " onerror=\"this.style.display=&quot;none&quot;;\" class=\"artwork-brick__image__img\"></a><div" + (jade.attr("data-id", artwork.id, true, true)) + " class=\"artwork-brick__image__save js-artwork-brick-save-controls\"></div></div><div class=\"artwork-metadata-stub\">");
if ( artwork.cultural_maker)
{
buf.push("<h4 class=\"artwork-metadata-stub__artists artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.cultural_maker) ? "" : jade_interp)) + "</h4>");
}
else if ( artwork.artists && artwork.artists.length)
{
buf.push("<h4 class=\"artwork-metadata-stub__artists artwork-metadata-stub__line\">");
// iterate artwork.artists
;(function(){
  var $$obj = artwork.artists;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var artist = $$obj[i];

buf.push("<a" + (jade.attr("href", artist.href, true, true)) + ">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
if (!( i === artwork.artists.length - 1))
{
buf.push(jade.escape(null == (jade_interp = ', ') ? "" : jade_interp));
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var artist = $$obj[i];

buf.push("<a" + (jade.attr("href", artist.href, true, true)) + ">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
if (!( i === artwork.artists.length - 1))
{
buf.push(jade.escape(null == (jade_interp = ', ') ? "" : jade_interp));
}
    }

  }
}).call(this);

buf.push("</h4>");
}
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + " class=\"artwork-metadata-stub__title artwork-metadata-stub__line\"><em>" + (jade.escape(null == (jade_interp = artwork.title) ? "" : jade_interp)) + "</em>");
if ( artwork.date)
{
buf.push(", " + (jade.escape((jade_interp = artwork.date) == null ? '' : jade_interp)) + "");
}
buf.push("</a>");
if ( artwork.collecting_institution)
{
buf.push("<div class=\"artwork-metadata-stub__partner artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.collecting_institution) ? "" : jade_interp)) + "</div>");
}
else if ( artwork.sale && artwork.sale.is_auction)
{
buf.push("<a" + (jade.attr("href", artwork.sale.href, true, true)) + " class=\"artwork-metadata-stub__partner artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.partner.name) ? "" : jade_interp)) + "</a>");
}
else if ( artwork.partner)
{
buf.push("<a" + (jade.attr("href", artwork.partner.href, true, true)) + " class=\"artwork-metadata-stub__partner artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.partner.name) ? "" : jade_interp)) + "</a>");
}
if ( artwork.sale_message && artwork.sale_message != 'Contact For Price' && !(artwork.sale && artwork.sale.is_auction))
{
buf.push("<div class=\"artwork-metadata-stub__sale-message artwork-metadata-stub__line\">" + (jade.escape(null == (jade_interp = artwork.sale_message) ? "" : jade_interp)) + "</div>");
}
var auctionPartner = artwork.partner && (artwork.partner.type === 'Auction' || artwork.partner.type === 'Auction House')
if ( artwork.sale && artwork.sale.is_auction)
{
if ( artwork.is_sold)
{
buf.push("<div class=\"artwork-metadata-stub__contact artwork-metadata-stub__line\">Sold</div>");
}
else
{
buf.push("<div class=\"artwork-metadata-stub__contact artwork-metadata-stub__line artwork-metadata-stub__bid-now\">");
var sa = artwork.sale_artwork
if ( artwork.sale.is_live_open)
{
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + ">Enter Live Auction</a>");
}
else if ( artwork.sale.is_open)
{
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + ">");
var bids = sa.counts.bidder_positions
if ( bids > 0)
{
buf.push("" + (jade.escape((jade_interp = sa.highest_bid.display) == null ? '' : jade_interp)) + "&nbsp;" + (jade.escape(null == (jade_interp = '(' + bids + (bids > 1 ? ' bids' : ' bid') + ')') ? "" : jade_interp)));
}
else
{
buf.push("" + (jade.escape((jade_interp = sa.opening_bid.display) == null ? '' : jade_interp)) + "");
}
buf.push("</a>");
}
else if ( artwork.sale.is_preview)
{
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + ">" + (jade.escape((jade_interp = sa.opening_bid.display) == null ? '' : jade_interp)) + "</a>");
}
else if ( artwork.sale.is_closed)
{
buf.push("Auction closed");
}
buf.push("</div>");
}
}
else if ( artwork.is_inquireable && !artwork.is_acquireable)
{
buf.push("<div class=\"artwork-metadata-stub__contact artwork-metadata-stub__line\"><a" + (jade.attr("href", artwork.href, true, true)) + (jade.attr("data-artwork_id", artwork._id, true, true)) + " data-context_type=\"artwork feed item\" class=\"analytics-artwork-contact-seller\">Contact " + (jade.escape((jade_interp = artwork.partner.type.toLowerCase()) == null ? '' : jade_interp)) + "</a></div>");
}
buf.push("</div></div></li>");
    }

  }
}).call(this);

buf.push("<li class=\"mgr-cell abrv-fillwidth-row js-mgr-cell\"><div class=\"abrv-fillwidth-row__view-all\"><a" + (jade.attr("href", viewAllUrl, true, true)) + " class=\"abrv-fillwidth-row__view-all__link\">View All</a></div></li></ul>");
}
else
{
if ( includeContext)
{
buf.push("<div class=\"abrv-context abrv-fillwidth-row abrv-context--float arbv-context--followed-artists\"><div class=\"abrv-context__content abrv-context__content--followed-artists\">");
if ( artists && artists.length)
{
// iterate artists
;(function(){
  var $$obj = artists;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var artist = $$obj[$index];

buf.push("<a" + (jade.attr("href", "/artist/" + (artist.id) + "", true, true)) + " class=\"abrv-context__content--followed-artists__artist\">" + (jade.escape(null == (jade_interp = artist.get('name')) ? "" : jade_interp)) + "</a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var artist = $$obj[$index];

buf.push("<a" + (jade.attr("href", "/artist/" + (artist.id) + "", true, true)) + " class=\"abrv-context__content--followed-artists__artist\">" + (jade.escape(null == (jade_interp = artist.get('name')) ? "" : jade_interp)) + "</a>");
    }

  }
}).call(this);

if ( counts.artists - artists.length > 0)
{
s = counts.artists - artists.length == 1 ? '' : 's'
buf.push("<a href=\"/works-for-you\" class=\"abrv-context__content--followed-artists__more-artists\">+" + (jade.escape((jade_interp = counts.artists - artists.length) == null ? '' : jade_interp)) + " more artist" + (jade.escape((jade_interp = s) == null ? '' : jade_interp)) + "</a>");
}
}
else
{
buf.push("<p>Follow artists for better recommendations and to receive alerts when new works are available</p><P><span>Or&nbsp;</span><a href=\"/artists\">Browse all artists</a></P>");
}
buf.push("</div></div>");
}
buf.push("<div class=\"arbv-follow-search-container\"><div id=\"arbv-follow-searchbar-container\" class=\"typeahead\"><input id=\"arbv-follow-search-container\" placeholder=\"Search for artists you like...\" class=\"bordered-input\"><a class=\"icon-search\"></a></div><div class=\"typeahead\"><div class=\"arbv-follow-results\">");
if ( artistResults)
{
buf.push("<div class=\"tt-dropdown-menu\">");
// iterate suggestions
;(function(){
  var $$obj = suggestions;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var suggestion = $$obj[$index];

buf.push("<div class=\"tt-suggestion\"><div" + (jade.attr("data-artist-slug", suggestion.get('id'), true, true)) + (jade.attr("data-artist-id", suggestion.get('_id'), true, true)) + " class=\"tt-suggestion-inner\"><div class=\"typeahead-suggestion-thumbnail\"><span><img" + (jade.attr("src", suggestion.has('thumb') ? suggestion.get('thumb').cropped.url : suggestion.cropUrlFor({ width: 32, height: 32 }), true, true)) + " width=\"32\" height=\"32\" onerror=\"this.style.display=&quot;none&quot;;\"></span></div><div class=\"typeahead-suggestion-name\">" + (jade.escape(null == (jade_interp = suggestion.get('name')) ? "" : jade_interp)) + "</div><div data-state=\"follow\" class=\"typeahead-suggestion-follow\"><div class=\"avant-garde-button-underlined\"></div></div></div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var suggestion = $$obj[$index];

buf.push("<div class=\"tt-suggestion\"><div" + (jade.attr("data-artist-slug", suggestion.get('id'), true, true)) + (jade.attr("data-artist-id", suggestion.get('_id'), true, true)) + " class=\"tt-suggestion-inner\"><div class=\"typeahead-suggestion-thumbnail\"><span><img" + (jade.attr("src", suggestion.has('thumb') ? suggestion.get('thumb').cropped.url : suggestion.cropUrlFor({ width: 32, height: 32 }), true, true)) + " width=\"32\" height=\"32\" onerror=\"this.style.display=&quot;none&quot;;\"></span></div><div class=\"typeahead-suggestion-name\">" + (jade.escape(null == (jade_interp = suggestion.get('name')) ? "" : jade_interp)) + "</div><div data-state=\"follow\" class=\"typeahead-suggestion-follow\"><div class=\"avant-garde-button-underlined\"></div></div></div></div>");
    }

  }
}).call(this);

buf.push("</div>");
}
buf.push("</div></div></div>");
}
if ( artworks && artworks.length)
{
buf.push("<nav class=\"mgr-navigation js-mgr-navigation\">");
if ( artworks && artworks.length)
{
buf.push("<nav" + (jade.cls(['mgr-navigation','js-mgr-navigation',isTouch ? 'is-touch' : ''], [null,null,true])) + "><a" + (jade.attr("disabled", disableStart, true, true)) + " class=\"mgr-arrow-left\"><div class=\"mgr-arrow-icon icon-chevron-left js-mgr-prev\"></div></a><a" + (jade.attr("disabled", disableEnd, true, true)) + " class=\"mgr-arrow-right\"><div class=\"mgr-arrow-icon icon-chevron-right js-mgr-next\"></div></a></nav>");
}
buf.push("</nav>");
}
buf.push("</div></div></div>");}.call(this,"artistResults" in locals_for_with?locals_for_with.artistResults:typeof artistResults!=="undefined"?artistResults:undefined,"artists" in locals_for_with?locals_for_with.artists:typeof artists!=="undefined"?artists:undefined,"artworks" in locals_for_with?locals_for_with.artworks:typeof artworks!=="undefined"?artworks:undefined,"counts" in locals_for_with?locals_for_with.counts:typeof counts!=="undefined"?counts:undefined,"disableEnd" in locals_for_with?locals_for_with.disableEnd:typeof disableEnd!=="undefined"?disableEnd:undefined,"disableStart" in locals_for_with?locals_for_with.disableStart:typeof disableStart!=="undefined"?disableStart:undefined,"includeContext" in locals_for_with?locals_for_with.includeContext:typeof includeContext!=="undefined"?includeContext:undefined,"isTouch" in locals_for_with?locals_for_with.isTouch:typeof isTouch!=="undefined"?isTouch:undefined,"s" in locals_for_with?locals_for_with.s:typeof s!=="undefined"?s:undefined,"showHeader" in locals_for_with?locals_for_with.showHeader:typeof showHeader!=="undefined"?showHeader:undefined,"suggestions" in locals_for_with?locals_for_with.suggestions:typeof suggestions!=="undefined"?suggestions:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;